import React from 'react';
import { message, Row } from 'antd';
import { FormOutlined, OrderedListOutlined } from '@ant-design/icons';
import NavItem from '../../components/nav-item';
import List from './list';
import getVersionMeta from '../../utils/get-version-meta';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const accId = window.__baseInfo.accId;
    const version = getVersionMeta();
    const versionCheck = async () => { 
        let response = await fetch(`/api/shop/my-list?accId=${accId}&status=1`);
        let result = await response.json();

        if(result?.data?.length >= version.shops) {
            message.error('当前版本已达到最大店铺数，请联系销售升级版本');
        }else {
            window.location.href = '/shop/create';
        }
    }
    
    return (
        <div>
            <Row gap={20} style={{ margin: '10px 0 0 0' }}>
                {!window.__baseInfo.isSub && <NavItem onClick={versionCheck} text="创建店铺">
                    <FormOutlined style={iconStyle} />
                </NavItem>}

                {/* <NavItem href="/shop/level-partner" text="合作等级管理">
                    <OrderedListOutlined style={iconStyle} />
                </NavItem>

                <NavItem href="/shop/level-user" text="用户等级管理">
                    <OrderedListOutlined style={iconStyle} />
                </NavItem> */}
            </Row>
            <List accId={accId} />
        </div>
    )
}